export * as useRestrictedMetrics from './useRestrictedMetrics';
import isEmpty from 'lodash-es/isEmpty';
import isNil from 'lodash-es/isNil';
import { useClient } from '../../ClientProvider';
import { NetworkType } from '../../enums';
import useQuery from '../../useQuery';
/**
 * Checks if the given org is also a network
 */
export const isNetwork = (org) => {
    return !isNil(org) && !isNil(org.networkType);
};
/**
 * Checks if the given org is also a network member
 */
export const isNetworkMember = (org) => {
    return !isNil(org) && !isNil(org?.subscribedNetworkId);
};
/**
 * Checks if the given org is part of a community network
 */
export const useIsMemberOfCommunityNetwork = (org) => {
    const client = useClient();
    const hasNetwork = isNetworkMember(org);
    const networkRequest = useQuery(client.networks.get(org?.subscribedNetworkId), {
        enabled: hasNetwork
    });
    const network = !isNil(networkRequest.data) ? networkRequest.data : undefined;
    return {
        isMemberOfCommunityNetwork: !isNil(network) && network.type === NetworkType.community,
        networkRequest
    };
};
/**
 * Checks if a user is part of any network
 */
export const useIsPartOfANetwork = (token) => {
    const client = useClient();
    const orgsRequest = useQuery(client.orgs.getAllPages(), {
        enabled: !isNil(token)
    });
    const availableOrgs = orgsRequest.data ?? [];
    // Checking if the users has access to one or many organizations that is also a network
    const canAccessANetworkOrg = !isEmpty(availableOrgs) &&
        availableOrgs.some((org) => [NetworkType.community, NetworkType.distribution, NetworkType.exclusiveDistribution].some((x) => x === org.networkType));
    // Checking if the user has access to one or many organizations that is part of a network
    const canAccessAnOrgInsideANetwork = !isEmpty(availableOrgs) && availableOrgs.some((org) => !isNil(org.subscribedNetworkId));
    return {
        orgsRequest,
        isPartOfANetwork: canAccessANetworkOrg || canAccessAnOrgInsideANetwork,
        canAccessANetworkOrg,
        canAccessAnOrgInsideANetwork
    };
};
